import api from "../utils/API";

// Base URL for your API
export const categoryService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/category", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  createCategory: async (payload) => {
    try {
      const response = await api.post("/admin/category", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  updateCategory: async (id, payload) => {
    try {
      const response = await api.put(`/admin/category/${id}`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  deleteCategory: async (id) => {
    try {
      const response = await api.delete(`/admin/category/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchCategoryById: async (id) => {
    try {
      const response = await api.get(`/admin/category/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchCategoryOptions: async () => {
    try {
      const response = await api.get(`/admin/category/all`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
